if (!customElements.get('free-gift-manager')) {
  customElements.define(
    'free-gift-manager',
    class FreeGiftManager extends BaseElement {
      connectedCallback() {
        super.connectedCallback();

        const triggerInCart = this.getAttribute('data-trigger-in-cart') === 'true';
        const giftVariantId = this.getAttribute('data-gift-variant-id');
        const giftLineKey = this.getAttribute('data-gift-line-key');

        if (triggerInCart && !giftLineKey) {
          this.addGift(giftVariantId);
        }
        else if (!triggerInCart && giftLineKey) {
          this.removeGift(giftLineKey);
        }
      }

      addGift(variantId) {
        this.addAbortController?.abort();
        this.addAbortController = new AbortController();

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: { '_free_gift': 'true' }
          }],
          sections: sectionsToBundle
        });

        fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body, signal: this.addAbortController.signal })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) return;

            const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
            cartJson['sections'] = parsedState['sections'];
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cart: cartJson });
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
          });
      }

      removeGift(lineKey) {
        this.removeAbortController?.abort();
        this.removeAbortController = new AbortController();

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: sectionsToBundle
        });

        fetch(theme.routes.cart_change_url, { ...theme.utils.fetchConfig(), body, signal: this.removeAbortController.signal })
          .then((response) => response.json())
          .then((parsedState) => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cart: parsedState });
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
          });
      }
    }
  );
}
